const progressBar = document.querySelector('.single-page-progress__bar');

if (progressBar) {
  document.body.classList.add('has-progress-bar');

  let removedSectionHeight = 0;
  let viewportHeight = 0;

  const removeSectionHeight = () => {
    const relatedProductsHeight = document.querySelector('.sc-related-products')?.clientHeight || 0;
    const latestBlogHeight = document.querySelector('.sc-latest-blog')?.clientHeight || 0;
    removedSectionHeight = relatedProductsHeight + latestBlogHeight;
  };

  const calculateViewportHeight = () => {
    viewportHeight = document.querySelector('main').clientHeight - window.innerHeight - removedSectionHeight;
  };

  const checkProgress = () => {
    const scrollPercent = (window.scrollY / viewportHeight) * 100;
    progressBar.style.width = `${scrollPercent}%`;
  };

  removeSectionHeight();
  calculateViewportHeight();
  checkProgress();

  const debouncedCalculateViewportHeight = debounce(() => {
    calculateViewportHeight();
    checkProgress();
  }, 250);

  window.addEventListener('resize', debouncedCalculateViewportHeight);

  window.addEventListener('scroll', () => {
    checkProgress();
  });
}
